<script lang="ts">
	import { Eye, EyeOff } from 'lucide-svelte';
	import Spinner from './Spinner.svelte';
	import type { HTMLInputAttributes } from 'svelte/elements';

	interface Props extends HTMLInputAttributes {
		value: string;
		label: string;
		pending?: boolean;
		errors?: string[];
	}

	let { value = $bindable(), label, pending = false, errors = [], ...rest }: Props = $props();

	let { name, type } = rest;

	function toggleVisibility() {
		if (!inputRef) return;
		if (inputRef.type === 'password') inputRef.type = 'text';
		else inputRef.type = 'password';
	}

	let inputRef: HTMLInputElement | undefined = $state();
</script>

<div class="{errors?.length ? 'error' : ''} flex flex-col">
	<label for={name} class="text-gray-dark mb-2">{label}</label>
	<div class="relative">
		<input bind:this={inputRef} bind:value {...rest} class="input" />
		{#if type === 'email'}
			{#if pending}
				<div class="absolute top-5 right-5">
					<Spinner />
				</div>
			{/if}
		{/if}
		{#if type === 'password'}
			<button
				type="button"
				onclick={toggleVisibility}
				class="absolute top-1/2 right-4 -translate-y-1/2 cursor-pointer"
			>
				{#if inputRef?.type === 'password'}
					<EyeOff class="w-5" />
				{:else}
					<Eye class="w-5" />
				{/if}
			</button>
		{/if}
	</div>
	{#each errors ?? [] as message}
		<p class="message mt-2 text-sm">{message}</p>
	{/each}
</div>

<style lang="postcss">
	@reference '../app.css';

	input {
		@apply h-[3.75rem];
	}

	.error {
		.message {
			@apply text-red-ticker;
		}

		input {
			@apply border-red-ticker border-2;
		}
	}
</style>
